<template>
  <v-tooltip color="#1b1b1b" right>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        v-show="mostrarBtnReset"
        @click="resetSelects"
        icon
        color="green"
      >
        <v-icon>mdi-cached</v-icon>
      </v-btn>
    </template>
    <span>Resetear selectores</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "buttonReset",
  props: {
    mostrarBtnReset: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {},
  data: () => ({}),
  methods: {
    resetSelects() {
      this.$emit("resetearSelectores");
    },
  },
};
</script>

<style></style>
